/**
 * Funnel-library slice of the English catalog (W15 carve-out).
 *
 * en.ts sits against the 500-line fileSize ceiling; the funnel vocabulary
 * moved here wholesale (spread back into `en` in en.ts - t() and MessageKey
 * unchanged). Add new funnels.* keys HERE.
 */
export const enFunnels = {
  'funnels.title': 'Funnels',
  /** Card badge (kind-alignment §2): kind-scoped funnels show the active
   *  kind's name; funnels with no `kinds` restriction show this instead. */
  'funnels.anyBusiness': 'Any business',
  'funnels.intro':
    'Everything running on your {kind} setup, grouped by the automation behind it. These switched themselves on when you connected your apps — nothing to build or save.',
  'funnels.family.chat': 'Chat & DM automation',
  'funnels.family.chat.sub': 'Runs on Instagram, Messenger and WhatsApp',
  'funnels.family.email': 'Email automation',
  'funnels.family.ads': 'Ads automation',
  'funnels.family.ads.sub': 'Paid traffic, attributed end to end',
  'funnels.family.payments': 'Payment automation',
  'funnels.family.payments.sub': 'Checkout, retries and card updates',
  'funnels.family.ops': 'Store & calendar automation',
  'funnels.family.ops.sub': 'Driven by orders, stock and bookings',
  'funnels.live': 'Live',
  'funnels.paused': 'Paused',
  'funnels.runningOn': 'Running on {names}',
  'funnels.runningOnPlatform': 'Running on your BuzzBit X data',
  'funnels.emailSendingShared': 'Email Sending (shared domain)',
  'funnels.connectOwnDomain': 'Connect your own domain',
  'funnels.connect': 'Connect {name}',
  'funnels.activate': 'Activate flow',
  'funnels.activating': 'Activating…',
  'funnels.setUp': 'Set up automation',
  'funnels.endToEnd': 'End-to-end',
  'funnels.showMore': 'Show {count} more automation groups',
  'funnels.showFewer': 'Show fewer',
  'funnels.awaitingData': 'Live — metrics appear here as this funnel runs.',
  'funnels.pausedHint': 'Connect {name} to switch this funnel on.',
  'funnels.activateHint': 'A ready-made flow is installed — activate it to switch this funnel on.',
  'funnels.setUpHint': 'Set up a comment automation to switch this funnel on.',
  'funnels.builderPrompt': "Need a funnel that isn't here? Build it step by step on the Automations canvas.",
  'funnels.openAutomations': 'Open Automations',
  'funnels.loadError': "Couldn't load pipeline data.",
  'funnels.recovered': '{amount} recovered',
  'funnels.campaignPerformance': 'Campaign performance',
  'funnels.utmAttribution': 'UTM attribution',
  'funnels.col.sourceCampaign': 'Source / campaign',
  'funnels.col.clicks': 'Clicks',
  'funnels.col.conversions': 'Conversions',
  'funnels.col.revenue': 'Revenue',
  'funnels.col.roas': 'ROAS',
  'funnels.col.channel': 'Channel',
  'funnels.col.customers': 'Customers',
  'funnels.purchase.journeyTitle': 'Ad → {transaction} journey',
  'funnels.purchase.label': 'Ads → {transaction}',
  'funnels.purchase.runs': 'Every ad click attributed through the store to the order it produced',
  'funnels.speed.label': 'Speed-to-lead',
  'funnels.speed.runs': 'Auto-reply within 60s of any new lead, on the channel they used',
  'funnels.social.label': 'Social DM → conversion',
  'funnels.social.runs': 'Comment & DM automation on Instagram, Messenger and WhatsApp',
  'funnels.nurture.label': 'Nurture → first {transaction}',
  'funnels.nurture.runs': 'Welcome series with one offer, paused on conversion',
  'funnels.winback.label': 'Win-back / reactivation',
  'funnels.winback.runs': 'Triggers at 60 days inactive with an incentive escalation',
  'funnels.abandon.label': 'Checkout abandonment',
  'funnels.abandon.runs': '3-step recovery on any unfinished checkout, booking or signup',
  'funnels.abandon.empty': 'No abandonment activity in this period yet.',
  'funnels.return.label': 'Return {persons}',
  'funnels.return.runs': 'Repeat-{transaction} journey: who comes back, and what brings them',
  'funnels.return.empty': 'No {transactions} yet.',
  'funnels.return.repeatRate': 'Repeat rate · 2+ {transactions}',
  'funnels.reviews.label': 'Reviews & reputation',
  'funnels.reviews.runs': 'Review ask sent after each fulfilled {transaction}',


  // ── W15: the kit's kind-specific funnels (BusinessKind.jsx.txt) ──
  'funnels.noshow.label': 'No-show recovery',
  'funnels.noshow.runs': 'Rebook nudge + next-day follow-up on every missed appointment',
  'funnels.lead.label': 'Lead follow-up',
  'funnels.lead.runs': 'Fast follow-up + booking nudge for every new lead',
  'funnels.complete.label': 'Completion & next step',
  'funnels.complete.runs': 'Congratulations + next-step nudge when a course is finished',
  'funnels.trial.label': 'Trial conversion',
  'funnels.trial.runs': 'Trial welcome + value case before the window closes',
  'funnels.dunning.label': 'Payment recovery',
  'funnels.dunning.runs': 'Calm dunning notice + reminder on failed payments',
  'funnels.expansion.label': 'Expansion & upsell',
  'funnels.expansion.runs': 'Upgrade thank-you + power features a week in',

  // ── Funnel library (GET /api/funnels) ─────────────────────────────────
  // The SAFETY-GATED catalog, and a different thing from the funnels.* keys
  // above: those describe the read-only Overview module, where a funnel is
  // live because the merchant connected the apps it needs. Here a funnel is
  // live because the merchant was shown who it reaches and said yes. The
  // `funnels.live` / `funnels.paused` badges are reused deliberately — one
  // vocabulary for "running" / "not running" across both surfaces.
  'hubTab.funnels': 'Funnel library',
  'funnelLib.title': 'Funnel library',
  'funnelLib.subtitle':
    'Ready-made automations — review who they reach before you switch them on.',
  'funnelLib.enabledCount': '{on} of {total} switched on',
  // While the kill switch or the cap holds, "2 of 8 switched on" is true and
  // misleading in the same breath — switched on is not the same as sending.
  'funnelLib.enabledCountPaused': '{on} of {total} switched on — none are sending right now',

  // States
  'funnelLib.loading': 'Loading your funnels…',
  'funnelLib.loadFailed': "Couldn't load your funnels.",
  'funnelLib.retry': 'Try again',
  'funnelLib.empty': 'No funnels are available for this business type yet.',
  'funnelLib.emptyHint':
    'Build a custom journey on the Automations canvas, or connect the apps your funnels need.',

  // Workspace-wide safety state — true for every card at once.
  //
  // 2026-08-23: this said "Sending is paused across BuzzBit X right now", and
  // the badge below said "nothing will go out". Both were false. The switch
  // reached exactly two send sites while campaigns, every flow email node,
  // chat-flow email and the WhatsApp / Instagram / Messenger nodes kept
  // sending. The server fix extended the switch to every MARKETING send site;
  // it deliberately does NOT stop transactional messages, because someone who
  // just booked an appointment is owed their confirmation whatever a marketing
  // freeze is doing. So the copy now names both halves. "Marketing" is the
  // word doing the work — drop it and the sentence becomes a lie again the
  // first time a merchant sees a booking confirmation land during a freeze.
  //
  // WHAT IS EXEMPT, precisely, because every earlier draft of this sentence
  // over-promised and each over-promise had a victim:
  //
  //   still sends — replies (inbox, AI, an inbound-triggered chat flow); the
  //     native in-conversation booking in chatFlowExecutor/bookingRunners;
  //     Resend receipts and invoices; verification, reset and invite mail;
  //     the Shopify order-confirmation and order-shipped WhatsApp templates;
  //     and EmailFlows whose trigger is in getFlowType's transactional set —
  //     order_paid, order_fulfilled, fulfillment_created, order_cancelled,
  //     refund_created — on every leg, email and WhatsApp alike.
  //
  //   paused — everything else, INCLUDING things a merchant would call
  //     transactional. `booking_scheduled` (the first-party pack flow
  //     "Service · Booking Confirmation" in data/serviceFlowPack.ts, both its
  //     email and WhatsApp nodes), and every reminder: `booking_reminder_24h`,
  //     `booking_reminder_2h`, `booking_no_show`, `member.access_granted`,
  //     `payment_failed`, `event_registered`. A merchant-authored flow on
  //     `order_placed` is held too. None are in getFlowType's transactional set.
  //
  // CORRECTED IN ROUND 2 — do not re-introduce this. An earlier version of this
  // block claimed the shipped "Order Confirmation" flow runs on
  // `order.created`/`order_placed` and is therefore held. It is NOT.
  // flowTemplates/transactionalFlows.ts FT-03 declares `triggerType:
  // 'order_paid'`, and routes/flows-quick-start.ts writes exactly that into
  // `EmailFlow.trigger`. The string `order.created` on that template is the
  // decorative `config.event` of its TRIGGER node and reaches nothing. So the
  // shipped order-confirmation flow SENDS during a freeze, and no first-party
  // template ships on `order_placed` at all.
  //
  // DECISION, made deliberately rather than by omission: those triggers are
  // NOT being reclassified. getFlowType's output also sets the ConsentGuard
  // purpose (nodeExecutors/emailNode.ts), so moving `booking_scheduled` or
  // `order_placed` into 'transactional' would make those flows bypass
  // marketing opt-out — changing WHO receives mail, not merely who is braked.
  // That is a consent-policy call with an owner, and it is not this one. The
  // claim is narrowed to match the code instead, and the second sentence
  // exists specifically so an operator reading this during an incident does
  // not assume a new booking still gets confirmed. It does not.
  // NON-CATEGORICAL, on the third attempt and deliberately. Every previous
  // version asserted a clean category over a system that does not have one —
  // "nothing will go out", then "confirmations still go out", then "booking and
  // order confirmations are paused too" — and each was false in a different
  // direction. Whether a given confirmation sends depends on ONE thing: its
  // flow's trigger. So the sentence says that, and names what survives instead
  // of promising a class. Awkward and true beats tidy and wrong.
  //
  // The two "most"s are load-bearing and were the fourth correction. Email
  // automations: six trigger types are transactional and exempt. Chat: the
  // brake is a NINE-TRIGGER ALLOWLIST, so a merchant-authored promo flow on
  // `course_completed` or `community_joined` still sends its message node to
  // anyone inside Meta's 24-hour window. Drop either "most" and the sentence
  // is categorical again, over a system that has no such category.
  'funnelLib.killSwitch':
    'Marketing sending is paused across BuzzBit X right now: no funnel, campaign or broadcast will send. Most email automations are held too, along with most promotional WhatsApp and Instagram messages. Things your customers are waiting on still go out — replies, payment receipts and refunds, and booking confirmations, reminders, reschedules and cancellations. Some order confirmations also send, depending on the flow’s trigger. You can still change these settings, but no funnel will send until it resumes.',
  'funnelLib.capReached':
    "This workspace has used today's send allowance of {cap}. Funnels stay on, and sending picks up again tomorrow.",
  // The short form of the two above, repeated on every card — the banner
  // explains it once, the card says it where the decision is made.
  // "nothing will go out" until 2026-08-23, which was the single most
  // load-bearing false sentence in the product: it is what an operator reads
  // to believe a freeze took hold.
  //
  // The replacement went through "confirmations still go out" (false — the
  // `booking_scheduled` pack flow is braked on both legs) and then "booking and
  // order confirmations too" (false in the OTHER direction — the shipped
  // order-confirmation flow runs on `order_paid` and sends, the WhatsApp
  // booking bot sends, and the Shopify order-confirmation template sends).
  //
  // Three wrong sentences, one cause: this badge kept trying to describe the
  // whole platform from a card that is about ONE funnel. It does not need to.
  // Every funnel goes through funnelSafety.gate(), so "this funnel will not
  // send" is exactly, narrowly true — and it is the only thing a merchant
  // reading this card is asking. The workspace-wide picture, with its
  // exceptions, belongs to the banner above, which now carries it.
  'funnelLib.badge.killSwitch': 'Paused platform-wide — this funnel will not send',
  'funnelLib.badge.capReached': "Today's send allowance is used up",

  // Card
  'funnelLib.needs': 'Needs {names}',
  'funnelLib.startsOn': 'Starts on {event}',
  'funnelLib.journey': 'The journey',
  'funnelLib.review': 'Preview and turn on',
  'funnelLib.checking': 'Checking who this reaches…',
  'funnelLib.turnOff': 'Turn off',
  'funnelLib.turningOff': 'Turning off…',
  'funnelLib.previewFailed': "Couldn't check who this funnel reaches.",
  'funnelLib.disableFailed': "Couldn't turn this funnel off.",
  // The badge is the most scannable thing on the card, so it must never be the
  // one element that says "running" while nothing can run.
  'funnelLib.onNotSending': 'On · not sending',

  // Preview → enable. The two numbers ARE the decision.
  'funnelLib.previewTitle': 'Before you turn on {label}',
  'funnelLib.matches': 'People this reaches',
  'funnelLib.consentEligible': 'Have agreed to hear from you',
  // NOT "the 300 will be emailed". The server's first-run throttle caps a
  // newly switched-on funnel at `firstDayCap` sends in its first 24 hours, so
  // a sentence promising the whole consented list is wrong by an order of
  // magnitude on day one — on the one screen whose job is to be exact about
  // who gets emailed. Reach and first-day volume are stated separately.
  'funnelLib.audienceLine':
    '{consent} of the {matches} people this reaches have agreed to hear from you. The other {rest} are never emailed.',
  'funnelLib.audienceLineAll':
    'All {matches} people this reaches have agreed to hear from you.',
  // Both of gate()'s volume ceilings, because stating one implies the other
  // does not exist. "then runs at full pace" was the first version of this
  // line and it was wrong the same way the sentence above it was: the
  // workspace daily cap is permanent, not a warm-up. Scope checked against the
  // code rather than assumed: sentToday() counts AutomationExecution rows with
  // status 'SENT', and funnelSafety.recordOutcome is the only writer of that
  // value — boardAutomationService writes 'success', recurringRowService
  // writes 'pending' — so the cap is shared among FUNNELS, not every
  // automation in the workspace.
  //
  // 2026-08-21: merchant-authored board rules now pass through the same gate,
  // which put "across all its funnels combined" at risk — one shared writer
  // and the cap would quietly start counting mail no funnel sent. So the
  // scope was kept rather than the sentence rewritten: a merchant rule's
  // successful send is recorded as 'SENT_AUTOMATION', a status of its own
  // (see boardAutomationEmailAction's `audit` helper). The audit table stays
  // complete — which matters, because funnelSafety calls it the only answer to
  // "why did my customer get this" — while sentToday()'s `status: 'SENT'`
  // filter still sees funnels alone. Refusals from both scopes write SKIPPED_*
  // rows, which sentToday() does not count either. The sentence below is
  // therefore still exactly true.
  'funnelLib.pace':
    'Not all at once: this funnel sends at most {cap} emails in its first 24 hours. After that this workspace sends at most {dailyCap} a day across all its funnels combined.',
  'funnelLib.noConsent':
    'Nobody this funnel reaches has agreed to hear from you yet, so it will not email anyone until someone does.',
  // 2026-08-21: the two numbers used to be the WHOLE customer list, identical
  // for all eight funnels. They are now the funnel's own audience, which made
  // two more states real and both need their own sentence:
  //
  //   matches === 0 — a standing audience that happens to be empty (no cart is
  //   abandoned right now). `noConsent` above would blame consent for it, so
  //   this says what is actually true instead.
  //   Deliberately does NOT say "you can turn it on": this line can render
  //   beside `funnelLib.blocked`, which says the opposite, and the connection
  //   notice is the one that has to win.
  'funnelLib.audienceNoneNow':
    'Nobody matches this funnel right now. It starts working the moment somebody does.',
  //   no standing audience at all — the trigger is a moment, not a population.
  //   There is no number here that is not invented, so these say so. One key
  //   per trigger because "runs on every new lead" and "runs on every failed
  //   payment" are different sentences, with `default` covering a trigger this
  //   build has not been taught (the server may ship a new one first).
  'funnelLib.perEvent.lead.created':
    'Nobody is waiting for this one. It runs once for each new lead that arrives after you turn it on.',
  'funnelLib.perEvent.order.created':
    'Nobody is waiting for this one. It runs once for each order placed after you turn it on.',
  'funnelLib.perEvent.order.fulfilled':
    'Nobody is waiting for this one. It runs once for each order you fulfil after you turn it on.',
  'funnelLib.perEvent.instagram.dm_received':
    'Nobody is waiting for this one. It runs once for each Instagram DM that arrives after you turn it on.',
  // `cart.abandoned` is per-event and NOT a standing count, which is not
  // obvious: carts sit in an ABANDONED state that looks countable. Nothing
  // re-scans that state — the event fires once, at abandonment time — so a
  // count of it would promise a send to people whose event already passed.
  'funnelLib.perEvent.cart.abandoned':
    'Nobody is waiting for this one. It runs once for each checkout abandoned after you turn it on.',
  'funnelLib.perEvent.saas.payment_failed':
    'Nobody is waiting for this one. It runs once for each payment that fails after you turn it on.',
  'funnelLib.perEvent.default':
    'Nobody is waiting for this one. It runs once for each {event} after you turn it on.',
  // The consent guarantee still holds without a number behind it, and it is
  // the same one funnelSafety.gate enforces at send time: funnel scope refuses
  // any recipient without emailConsent, so this is a statement about the code,
  // not a reassurance.
  'funnelLib.perEventConsent':
    'Everyone it emails will have agreed to hear from you first. Anyone who has not is skipped, every time.',
  // Enabling refuses server-side while a required connection is missing
  // (funnelRequirements.ts), so the dialog says it BEFORE the button rather
  // than after — a "Preview again" loop cannot connect an app.
  'funnelLib.blocked': 'Connect {names} first. Until then this funnel has no way to run.',
  'funnelLib.confirm': 'Turn it on',
  'funnelLib.enabling': 'Turning on…',
  'funnelLib.cancel': 'Cancel',
  'funnelLib.close': 'Close',
  'funnelLib.previewAgain': 'Preview again',
  'funnelLib.enableFailed': "Couldn't turn this funnel on.",
  /**
   * One sentence, two places: under the disabled button when the merchant's
   * role is known to lack EDIT_BOARDS, and under the server's message when a
   * 403 says so anyway. The roles named mirror
   * server/src/services/rbac/rolePermissionMatrix.ts — EDITOR holds
   * EDIT_BOARDS too, so "owner or admin" named too high a bar.
   */
  'funnelLib.viewOnly':
    'Your role can look at funnels but not switch them on. An owner, admin or editor of this workspace can.',

  // What a funnel needs connected (server FunnelRequirement).
  'funnelLib.req.email': 'Email',
  'funnelLib.req.whatsapp': 'WhatsApp',
  'funnelLib.req.instagram': 'Instagram',
  'funnelLib.req.store': 'a store',
  'funnelLib.req.payments': 'payments',

  // V37: an ACTIVE flow on the same event answers it; the funnel's email is
  // skipped for every lead that flow emails (V51: and only for those).
  'funnelLib.handledByFlow': 'Handled by flow «{name}». This funnel skips its own email for every lead that flow welcomes.',
  'funnelLib.handledByFlowSegment': 'Flow «{name}» welcomes the leads in its segment. This funnel still emails everyone else.',
  'funnelLib.openFlow': 'Open flow',

  // My Automations — the Hub funnels that are switched on.
  'hubFunnels.title': 'Hub funnels',
  'hubFunnels.on': 'On',
  'hubFunnels.openInHub': 'Open in Hub',
  'hubFunnels.handledBy': 'Email handled by flow «{name}»',
  'hubFunnels.handledBySegment': 'Email handled by flow «{name}» for leads in its segment',

  // Business Hub KPI tile whose data source cannot be connected in the app yet
  // (V38) — said plainly, with no link to a page that has nothing to connect.
  'hub.kpi.notAvailableYet': 'Not available yet for this kind of business.',
  // V54: Stripe and the course-platform webhook connect in-app, so a tile
  // waiting on one names it and links to its sheet.
  // Marketing-approved wording, 2026-10-05 (dispatch 45): exactly these two.
  'hub.kpi.needs.stripe': 'Needs Stripe. Connect it in Account → Integrations.',
  'hub.kpi.needs.course': 'Needs a course platform. Connect it in Account → Integrations.',
  'hub.kpi.connectSource': 'Connect {source}',
  'hub.kpi.source.stripe': 'Stripe',
  'hub.kpi.source.course': 'your course platform webhook',

  // P7 2026-10-10: a Hub tile with no number renders "—" and says why, instead
  // of a 0 standing in for "unknown". Marketing to review wording.
  'hub.tile.unavailable': 'Not available: {reason}',
  'hub.tile.defaultTransactions': 'orders',
  'hub.tile.reason.noAttendance': 'Nothing marked attended or no-show in the last 30 days. Mark past {transactions} to see this.',
  'hub.tile.reason.noEnrollments': 'No enrollments yet. This fills in when your course platform sends the first one.',
  'hub.tile.reason.noPricedSubscriptions': 'Your active subscriptions carry no readable price yet.',
  'hub.tile.reason.subscriptionRevenue': "Stripe subscription payments aren't counted here yet. MRR shows your recurring revenue.",
  'hub.tile.reason.comingSoon': 'Coming soon',
  'hub.tile.reason.notConnected': 'Needs a connected source. Connect it in Account → Integrations.',
  'hub.tile.reason.noSends': 'No emails sent yet. Rates appear after your first send.',
  'hub.tile.reason.noPaidOrders': 'No paid orders in the last 30 days.',
  'hub.tile.reason.noOrders': 'No orders recorded yet.',
  'hub.tile.reason.noRevenue': 'No revenue recorded in this period.',
  'hub.tile.reason.needsCosts': 'Add product costs to see this.',
  'hub.tile.reason.noContacts': 'No contacts yet.',
  'hub.tile.reason.loadFailed': "Couldn't load this number. Refresh the page to try again.",
  'hub.tile.reason.noProducts': 'No products yet.',
  'hub.tile.reason.noPayments': 'No payments recorded yet.',
  'hub.acquisition.newPeople': 'New {people}',
  'hub.acquisition.emptyChannels':
    'No attributed customers yet — attribution captures from popups, landing pages, ads, bookings and emails.',
  'hub.acquisition.emptySources':
    'No sources connected yet — connect your store, ads and messaging accounts to attribute customers automatically.',
  'hub.empty.noOrders': 'No recent orders',
  'hub.empty.noEmailSends': 'No email sends yet',
  'hub.empty.noPurchases': 'No purchases yet',
  'hub.empty.manageFlows': 'Manage flows',
  'hub.finance.pnlEmptyTitle': 'No P&L data yet',
  'hub.finance.pnlEmptyBody':
    'Connect your store and payments so revenue and costs can land here.',
  'hub.finance.expensesEmptyTitle': 'No expenses yet',
  'hub.finance.expensesEmptyBody': 'Add your first recurring expense to get started.',
  'hub.finance.addExpense': 'Add expense',
  'hub.finance.taxEmptyTitle': 'No tax estimates yet',
  'hub.finance.taxEmptyBody':
    'Tax estimates appear once revenue and expenses are flowing into Finance.',
  'hub.tile.reason.unknown': 'Not available yet.',
  'hub.tile.scopeFirst': 'First {shown} of {total}',
  'hub.tile.scopeLatest': 'Latest {shown} of {total}',
} as const;
